import { PersonRequest } from "@plinknz/tah-website-elements";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { signatureConfig } from "./config-generics/signature";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { UserData } from "../reducers/user";
import { overviewConfig } from "./config-generics/overview";
import { bankConfig } from "./config-generics/bank-details";

export const createSurveyConfig = (member: PersonRequest, user?: UserData) => {
    const personalConfig = personalDetailsConfig({
        member,
        children: user.onSameEmail,
    });

    const overviewDetailsConfig = overviewConfig({
        heading: "Tahua Hauora | Hauora Grant",
        content: [
            {
                heading: "Overview",
                lines: [
                    `Supports health-related expenses such as glasses, dental
                    work, hearing aids, and other approved medical costs. It is
                    for registered Ngāti Kuia whānau needing financial
                    assistance to access essential hauora services.`,
                ],
            },
            {
                heading: "Eligibility",
                lines: [
                    "To apply for this grant, you must:",
                    [
                        "Be a registered member of Ngāti Kuia",
                        "Provide proof of bank account (deposit form or electronic statement).",
                        "Provide a quote or invoice for the health service or equipment required.",
                    ],
                ],
            },
            {
                heading: "Key Dates & Deadlines",
                lines: [
                    [
                        "Deadline: applications can be made anytime and decisions are made as quickly as possible to ensure timely support.",
                        "Payment: will be made directly to the health provider.",
                    ],
                ],
            },
            {
                heading: "Funding Available",
                lines: [
                    "Up to $200 is available per health issue per person. A second grant application may be considered depending on the remaining grant budget.",
                ],
            },
            {
                heading: "Documents You'll Need",
                lines: [
                    [
                        "Bank account details (deposit form or electronic statement).",
                        "A quote or invoice for the health service or equipment required.",
                    ],
                ],
            },
        ],
    });

    const otherConfig: PageConfig[] = [
        {
            name: "circumstances",
            title: "Event - Kaupapa",
            questions: [
                {
                    name: "details",
                    title: "Provide details of the health related expense.",
                    placeHolder: "Kaupapa",
                    type: "comment",
                    isRequired: true,
                },
                {
                    type: "file",
                    name: "attachments",
                    title: `
                        Please upload any supporting documentation relevant to
                        your application (e.g. quote or invoice). If you are
                        unable to upload, please email directly to
                        grant@ngatikuia.iwi.nz.
                    `,
                    storeDataAsText: false,
                    allowMultiple: true,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                },
            ],
        },
    ];

    const pages: PageConfig[] = [
        ...overviewDetailsConfig,
        ...personalConfig,
        ...bankConfig,
        ...otherConfig,
        ...signatureConfig,
    ];

    return { pages };
};
